import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { LinkCategory, internalLinkCategories, getRelevantLinkCategories } from '@/data/internalLinks';

interface InternalLinkModuleProps {
  /** Blog post categories for contextual relevance sorting */
  postCategories?: string[];
  /** Current page path to exclude from links */
  currentPath?: string;
  /** Section heading — defaults to "Explore Prop Firm Reviews" */
  heading?: string;
  /** Max categories to display (default: all) */
  maxCategories?: number;
}

export function InternalLinkModule({
  postCategories,
  currentPath,
  heading = 'Explore Prop Firm Reviews',
  maxCategories,
}: InternalLinkModuleProps) {
  const categories: LinkCategory[] = postCategories?.length
    ? getRelevantLinkCategories(postCategories, currentPath)
    : internalLinkCategories.map(cat =>
        currentPath
          ? { ...cat, links: cat.links.filter(l => l.path !== currentPath) }
          : cat,
      ).filter(cat => cat.links.length > 0);

  const display = maxCategories ? categories.slice(0, maxCategories) : categories;

  if (!display.length) return null;

  return (
    <div className="bg-white dark:bg-gray-800/80 border border-gray-100 dark:border-gray-700/30 rounded-lg p-5 shadow-sm">
      <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">{heading}</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {display.map(cat => (
          <div key={cat.heading}>
            <h3 className="font-medium text-sm text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-2">
              {cat.heading}
            </h3>
            <ul className="space-y-1.5">
              {cat.links.map(link => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="inline-flex items-center gap-1.5 text-sm text-brand-blue dark:text-blue-400 hover:underline"
                  >
                    <ChevronRight className="h-3.5 w-3.5 shrink-0" />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
